module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calculation_in_progress":"--","no_data":"--"},"fr":{"calculation_in_progress":"--","no_data":"--"},"de":{"calculation_in_progress":"--","no_data":"--"}}')
  delete Component.options._Ctor
}
